export default __webpack_public_path__ + "static/media/Grid3.5.bce0045d.jpg";